<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="svg-block" :class="!isDetail && 'isDetail'" v-html="svg"></div>
</template>

<script setup lang="tsx">
import { ref, withDefaults, defineProps } from 'vue';

const props = withDefaults(
  defineProps<{ isDetail?: boolean; pageNo?: string }>(),
  {
    isDetail: false,
    pageNo: '01'
  }
);

const svg = ref(`
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 78.883 68">
    <g id="yema8" transform="translate(-256 -498)">
      <rect id="矩形_2891" data-name="矩形 2891" width="78.883" height="3" transform="translate(256 563)" fill="var(--theme-color-1)"/>
      <rect id="矩形_2892" data-name="矩形 2892" width="78.883" height="3" transform="translate(256 498)" fill="var(--theme-color-1)"/>
      <text id="_01" data-name="01" transform="translate(279 544)" fill="var(--theme-color-1)" font-size="32" font-weight="600"><tspan x="0" y="0">${props.pageNo}</tspan></text>
    </g>
  </svg>
`);
</script>
<style lang="scss" scoped>
@import './index.scss';
.isDetail {
  position: absolute;
  bottom: 20px;
  right: 10px;
}
</style>
